import { FormikProps } from "formik";
import { InputAppearanceValue } from "@volkswagen-onehub/components-core";

export const getFieldProps = (
  formik: FormikProps<any>,
  name: string,
  translationHandler: any
): {
  name: string;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onBlur: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  value: any;
  message: string | undefined;
  appearance: InputAppearanceValue | undefined;
} => ({
  name,
  onChange: (e) => handleChange(e, name, formik),
  onBlur: () => handleBlur(name, formik),
  value: formik.values[name],
  message:
    formik.touched[name] && formik.errors[name]
      ? translationHandler(formik.errors[name])
      : undefined,
  appearance:
    formik.touched[name] && formik.errors[name]
      ? ('error' as InputAppearanceValue)
      : undefined,
});

const handleBlur = (fieldName: string, formik: FormikProps<any>,) => {
  formik.setFieldTouched(fieldName, true);
};

const handleChange = (
  e: React.SyntheticEvent<HTMLInputElement>,
  fieldName: string,
  formik: FormikProps<any>,
) => {
  const value = e.currentTarget.value;

  formik.setFieldValue(fieldName, value);
};